import { useState } from "react";
import { func, object } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { removeTeamMemberQuery } from "@query";
import { Alert, Avatar, TableCell, TableRow } from "@components";
import { CircularProgress, Grid, IconButton } from "@material-ui/core";
import { Trash } from "@assets";
import useStyle from "./UserRow.style";

export const ContractorRow = observer(({
  user,
  reloadData,
}) => {
  const classes = useStyle();
  const { t } = useTranslation();

  const [removeAlertVisible, openRemoveAlert] = useState(false);
  const [alertLoading, setAlertLoading] = useState(false);

  const {
    uuid,
    fullname,
    avatar,
    avatarColor,
    company,
    email,
    status,
  } = user;

  const removeContractor = async () => {
    setAlertLoading(true);
    await removeTeamMemberQuery(uuid);
    openRemoveAlert(false);
    setAlertLoading(false);
    reloadData();
  };

  return (
    <TableRow>
      <TableCell big width={320} flexible>
        <Grid item container wrap="nowrap" alignItems="center">
          {
            <Avatar
              fullname={fullname}
              avatar={avatar}
              color={avatarColor}
              size={40}
            />
          }
          <Grid
            item
            container
            direction="column"
            className="ml-2"
            style={{ width: "calc(100% - 48px)" }}
          >
            <Grid item container>
              <p className="font-bold text-md">{ fullname }</p>
            </Grid>
            <p className="transparent-2">{ email }</p>
          </Grid>
        </Grid>
      </TableCell>
      <TableCell big width={240}>
        { company }
      </TableCell>
      <TableCell className={classes[`status${status}`]} big width={80}>
        { t(`views.team.status${status}`) }
      </TableCell>
      <TableCell className="justify-right" big width={34}>
        <IconButton
          color="primary"
          onClick={() => openRemoveAlert(true)}
          aria-label="menu"
          size="small"
        >
          <Trash color="error" />
        </IconButton>
        {
          removeAlertVisible &&
          <Alert
            isOpen={removeAlertVisible}
            onAccept={removeContractor}
            onCancel={() => openRemoveAlert(false)}
            title={t("views.team.remove_contractor", { name: fullname })}
            acceptText={
              alertLoading ? (
                <CircularProgress
                  aria-label="progress indicator"
                  size={24}
                  color="inherit"
                />
              ) : (
                t("common.delete")
              )
            }
          />
        }
      </TableCell>
    </TableRow>
  );
});

ContractorRow.propTypes = {
  user: object.isRequired,
  reloadData: func.isRequired,
};
